import { GraphMode, ItemType } from '../../constants';
import { AddCommandParams } from '../../types';
import { guid } from '../../utils';
import { BaseCommand, baseCommand } from '../base';

export const addCommand: BaseCommand<AddCommandParams> = {
  ...baseCommand,
  params: {
    type: ItemType.Node,
    model: { id: '' },
  },

  canExecute(graph) {
    if (graph.getCurrentMode() === GraphMode.Readonly) return false;
    return true;
  },

  init() {
    const { model } = this.params;

    if (model.id) return;

    model.id = guid();
  },

  execute(graph) {
    if (graph.getCurrentMode() === GraphMode.Readonly) return false;

    const { type, model } = this.params;

    graph.add(type, model);
  },

  undo(graph) {
    const { model } = this.params;

    if (model.id) {
      graph.remove(model.id);
    }
  },
};

export default addCommand;
